<template>
  <div class="order" :style="bannerFlag ? 'margin-top: 56px;':''">
    <div class="order-list w" style="min-height: calc(100vh - 125px);">
      <div class="search-box">
        <div class="search-box-left">
          <div class="search-item">
            <el-input size="mini" placeholder="服务单号" prefix-icon="el-icon-search" v-model="queryParams.servOrderNo"
              clearable @keyup.enter.native="querySearch" @clear="querySearch">
            </el-input>
          </div>

          <div class="search-item">
            <el-input size="mini" placeholder="患者名称" prefix-icon="el-icon-search" v-model="queryParams.demPatient"
              clearable @keyup.enter.native="querySearch" @clear="querySearch">
            </el-input>
          </div>

          <div class="search-item">
            <el-cascader v-model="queryParams.servCataId" :options="common.category" :props="optionProps" clearable
              :show-all-levels="false" size="mini" placeholder="服务单类型" @change="changeServCataId">
            </el-cascader>
          </div>

          <div class="search-item">
            <el-select size="mini" v-model="queryParams.orderStatus" placeholder="服务单状态">
              <el-option class="option-item" v-for="item in common.dict.get('biz_order_status')" :key="item.value"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="search-item">
            <el-switch v-model="queryParams.orderRushFlag" active-color="#00a5d5" inactive-color="#909399"
              active-value="1" inactive-value="0" active-text="加急" @change="changeOrderRushFlag">
            </el-switch>
          </div>
        </div>

        <div class="search-box-right">
          <y-button text="搜索" classStyle="main-btn ml" @btnClick="querySearch"></y-button>
          <y-button text="重置" classStyle="main-btn ml" @btnClick="resetSearch"></y-button>
        </div>

      </div>

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="height: calc(100vh - 258px);">

        <div class="table-wrap" style="height: calc(100vh - 238px);">

          <el-table ref="multipleTable" :data="orderList" tooltip-effect="dark" style="width: 100%;font-size: 13px;"
            size="small" :stripe="true" border @selection-change="handleSelectionChange" v-if="orderList.length > 0">

            <el-table-column type="selection" width="39"></el-table-column>

            <el-table-column align="center" label="序号" width="47" show-overflow-tooltip>
              <template #default="scope">
                <span>{{(queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>

            <el-table-column header-align="center" align="left" label="服务单号" width="200" show-overflow-tooltip>
              <template #default="scope">
                <div class="code-wrap">
                  {{scope.row.servOrderNo}}
                  <img src="/static/images/rush.png" v-if="scope.row.orderRushFlag === '1'">
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="demPatient" label="患者名称" width="73" align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column label="服务单类型" align="center" width="120" show-overflow-tooltip>
              <template #default="scope">
                <serv-tag :code="scope.row.servCataId" />
              </template>
            </el-table-column>

            <el-table-column label="金额" width="65" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{parseMoney(scope.row.orderAmount)}}
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" width="143" align="center" show-overflow-tooltip>
            </el-table-column>
            <!-- 倒计时文字状态 -->
            <el-table-column :key="desKey+1" label="设计计时" width="120" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="designTime(scope.row,'未激活')" class="txtColor1">
                  未激活
                </span>
                <span v-else-if="designTime(scope.row,'已锁定')" style="color: darkorange;">
                  已锁定
                </span>
                <span v-else-if="designTime(scope.row,'设计完成')" class="txtColor2">
                  设计完成
                </span>
                <span v-else-if="designTime(scope.row,'/')">
                  /
                </span>
                <span v-else-if="designTime(scope.row,'已超时')" class="txtColor3">
                  已超时
                </span>
                <span v-else-if="scope.row.orderStatus == '20'">
                  {{timeFormat(scope.row.desTime)}}
                </span>
              </template>
            </el-table-column>
            <el-table-column :key="confirmKey" label="待确认计时" width="120" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span
                  v-if="confirmTime(scope.row,'未激活')" class="txtColor1">
                  未激活
                </span>
                <span v-else-if="confirmTime(scope.row,'已锁定')" style="color: darkorange;">
                  已锁定
                </span>
                <span v-else-if="confirmTime(scope.row,'确认完成')" class="txtColor2">
                  确认完成
                </span>
                <span v-else-if="confirmTime(scope.row,'/')">
                  /
                </span>
                <span v-else-if="confirmTime(scope.row,'已超时')" class="txtColor3">
                  已超时
                </span>
                <span v-else-if="['30','31','40'].includes(scope.row.orderStatus)">
                  {{timeFormat(scope.row.confirmTime)}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="138">
              <template #default="scope">
                <dict-tag style="display: inline;cursor: default;" dict="biz_order_status"
                  :value="scope.row.orderStatus" />
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="143">
              <template #default="scope">
                <s-button text="详情" @btnClick="clickDetail(scope.row.servOrderId)"></s-button>
                <s-button text="支付" @btnClick="getPayDetail(scope.row)" v-if="scope.row.orderStatus == '01'"></s-button>
                <s-button text="删除" @btnClick="removeOrder(scope.row)"
                  v-if="scope.row.orderStatus == '91'||scope.row.orderStatus == '92'"></s-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="no-data" v-if="noData">
            暂无数据
          </div>
        </div>
        <div class="pagination-wrap" v-if="orderList.length">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
            :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <el-dialog :modal="false" :fullscreen="true" :modal-append-to-body="false" :visible.sync="dialogDetailVisible"
        :show-close="false" class="dialog-wrap" :key="'detail_' + orderDetail.servOrderId">
        <div slot="title" class="dialog-wrap-header">
          <div class="dialog-header">
            {{orderDetail.servName}}<label> - </label>{{orderDetail.servOrderNo}}<label> -
            </label>{{orderDetail.demPatient}}
            <img src="/static/images/rush.png" v-if="orderDetail.orderRushFlag === '1'">
          </div>
          <div>
            <y-button text="投诉" classStyle="main-btn" @btnClick="complaintFormVisible = true"
              v-if="['20', '30', '31', '40'].includes(orderStatus)&&orthodonticsOverTime('投诉')"></y-button>
            <y-button text="更改设计" classStyle="main-btn" @btnClick="dialogFormVisible = true"
              v-if="['30', '31'].includes(orderStatus) && overTimeFlag && orthodonticsPayTag && orthodonticsOverTime('更改设计')"></y-button>
            <y-button text="确认服务单" classStyle="main-btn" @btnClick="clickConfirmOrder"
              v-if="orderStatus == '30'"></y-button>
            <y-button text="补缴费用" classStyle="main-btn" @btnClick="clickConfirmOrder"
              v-if="orderStatus == '31'&&orthodonticsOverTime('补缴费用')"></y-button>
              <y-button text="修改服务单" classStyle="main-btn" @btnClick="clickUpdateOrder"
              v-if="['01', '10', '60'].includes(orderStatus)"></y-button>
            <y-button text="取消服务单" classStyle="main-btn" @btnClick="debouncedClick"
              v-if="cancelOrder"></y-button>
            <y-button text="返回" classStyle="main-btn" @btnClick="clickCloseDetail"></y-button>
          </div>
        </div>
        <div class="dialog-wrap-content">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane name="info">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-data-analysis"></i>
                <span>服务单详情</span>
              </span>
              <div class="tabs-pane-content">
                <detail-order v-if="!['4010110','4010120','3010130'].includes(orderDetail.servCataId)" :orderDetail="orderDetail" :implList="implList"></detail-order>
                <orth-order v-if="['3010130'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></orth-order>
                <active-order v-if="['4010110','4010120'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></active-order>
              </div>
            </el-tab-pane>

            <el-tab-pane name="data">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-film"></i>
                <span>数据下载</span>
              </span>
              <div class="tabs-pane-content">
                <detail-down :orderDetail="orderDetail"></detail-down>
              </div>
            </el-tab-pane>

            <el-tab-pane name="design">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-finished"></i>
                <span>设计信息</span>
              </span>
              <div class="tabs-pane-content">
                <detail-design :orderDetail="orderDetail"></detail-design>
              </div>
            </el-tab-pane>
            <el-tab-pane name="activity">
              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-timer"></i>
                <span>进度详情</span>
              </span>
              <div class="tabs-pane-content">
                <detail-activity :orderDetail="orderDetail"></detail-activity>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-dialog :visible.sync="dialogFormVisible" width="30%" margin-top="20vh" append-to-body>
          <div slot="title" class="pay-wrap-header">
            <span>申请更改设计单</span>
          </div>
          <el-form label-position="left" :model="ruleForm" ref="ruleForm">
            <el-form-item prop="content" label="更改理由:" label-width="120px"
              :rules="{ required: true, message: '更改理由不能为空', trigger: 'blur'}">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="ruleForm.content"
                placeholder="请详细说明需要更改的内容"></el-input>
            </el-form-item>
            <el-form-item label="图片说明:" label-width="120px">
              <el-upload list-type="picture-card" action :http-request="uploadFile"
                :data="{objectType:'18',objectTag: orderDetail.servOrderId}" :auto-upload="true" :limit="3" multiple
                :show-file-list="true" :before-upload="beforeUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm','1')">提 交</el-button>
          </div>
        </el-dialog>
      </el-dialog>
      <el-dialog :visible.sync="complaintFormVisible" width="30%" margin-top="20vh" append-to-body>
        <div slot="title" class="pay-wrap-header">
          <span>申请投诉设计师</span>
        </div>
        <el-form label-position="left" :model="ruleForm" ref="ruleForm">
          <el-form-item prop="content" label="投诉理由:" label-width="120px"
            :rules="{ required: true, message: '投诉理由不能为空', trigger: 'blur'}">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="ruleForm.content"
              placeholder="请详细说明投诉的原因"></el-input>
          </el-form-item>
          <el-form-item label="图片说明:" label-width="120px">
            <el-upload list-type="picture-card" action :http-request="uploadFile"
              :data="{objectType:'18',objectTag: orderDetail.servOrderId}" :auto-upload="true" :limit="3" multiple
              :show-file-list="true" :before-upload="beforeUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="complaintFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm','2')">提 交</el-button>
        </div>
      </el-dialog>
      <el-dialog :modal="false" :fullscreen="true" :modal-append-to-body="false" :visible.sync="dialogPayVisible"
        :show-close="false" class="dialog-wrap" :key="'pay_' + orderDetail.servOrderId">

        <div slot="title" class="pay-wrap-header">
          <span>服务单支付</span>
        </div>
        <div class="pay-wrap-content">
          <pay-order @cancelPay="clickClosePay" :orderPayDetail="orderPayDetail"></pay-order>
        </div>
      </el-dialog>
    </div>
    <Customer class="customerSer" :friendUid="orderDetail.desUserId"></Customer>
  </div>

</template>
<script>
  import YShelf from '/components/YShelf'
  import YButton from '/components/YButton'
  import SButton from '/components/SButton'
  import BaseTag from '/components/BaseTag'
  import DictTag from '/components/DictTag'
  import ServTag from '/components/ServTag'
  import DetailOrder from './detailOrder';
  import ActiveOrder from './activeModification/activeDetail';
  import OrthOrder from './orthodonticsOrder/orthodonticsOrderDetail';
  import DetailDown from './detailDown';
  import DetailDesign from './detailDesign';
  import DetailActivity from './detailActivity';
  import PayOrder from './payOrder';
  import CountDown from '/components/countDown'
  import Customer from './components/customerSer'
  import {
    getStore
  } from '/utils/storage'
  import {
    mapState
  } from 'vuex'
  import {
    uploadByPieces
  } from "../../../common/upload.js";
  let that;
  export default {
    data() {
      return {
        timerId: null,
        bannerFlag: false,
        loading: true,
        noData: false,
        orderList: [],
        selectIds: [],
        total: 0,
        queryParams: {
          pageNum: 1,
          pageSize: 15,
          servOrderNo: '',
          demPatient: '',
          servCataId: [],
          orderStatus: '',
          orderRushFlag: '',
          delFlag: '0'
        },
        orderDetail: {},
        orderPayDetail: {},
        dialogDetailVisible: false,
        dialogPayVisible: false,
        confirmVisible: false,
        activeName: 'info',
        optionProps: {
          value: 'servId',
          label: 'servName',
          children: 'children',
          expandTrigger: 'hover'
        },
        ruleForm: {
          content: ''
        },
        reasonImages: [],
        dialogFormVisible: false,
        complaintFormVisible: false,
        confirmKey: 0,
        desKey: 0,
        activityList: [],
        implList: [], //植体系统
        orderStatus: '', //订单状态
        timing: '', //获取订单状态的定时任务
        timeDown: '', //预期时间减去当前时间的定时任务
        paymentFee: 0, //补缴费用
        debounceTimer: null,// 防抖定时器
        externalTime:'',//服务器时间
        submitLock:false,
      }
    },
    watch: {
      dialogDetailVisible(){
        // 订单详情弹窗关闭清空session
        if(this.dialogDetailVisible==false){
          sessionStorage.clear()
        }
      }
    },
    computed: {
      ...mapState(['common', 'user']),
      //判断是否补缴费用
      orthodonticsPayTag() {
        return this.orderDetail.orthodonticsData.payTime != null ? false : true;
      },
      orthodonticsOverTime() {
        return function(msg) {
          // 倒计时小于0，则锁定服务单操作 --正畸待补缴超时
          let status = this.orderDetail.orderStatus;
          if (this.orderDetail.servCataId == '3010130') {
            let time = new Date(this.orderDetail.expectTime).getTime() - this.externalTime;
            return time <= 0 ? false : true;
          } else {
            // 上一个订单状态是设计师投诉、待接单、待支付
            let state = msg=='更改设计'||msg == '投诉';
            if (['31'].includes(status)&&state) {
              return false;
            }
          }
          return true;
        }
      },
      overTimeFlag() {
        let time = new Date(this.orderDetail.expectTime).getTime() - this.externalTime;
        return time < 1800000 ? false : true;
      },
      //取消订单
      cancelOrder(){
        let id = this.orderDetail.servCataId;
        let status = this.orderDetail.orderStatus;
        let list = id=='3010130'?['01', '10', '60']:['01', '10','31', '60'];
        if(list.includes(status)){
          return true;
        }else{
          return false;
        }
      },
      // 设计计时
      designTime(){
        return function(row,msg){
          let flag = false;
          let list = [];
          let statusFlag = '';
          let id = row.servCataId;
          let status = row.orderStatus;
          let str = this.timeFormat(row.desTime) == '已超时';
          switch(msg){
            case '未激活':
            list = id=='3010130'?['01','02','10','70','91']:['01','02','10','31','70','91'];
            statusFlag = list.includes(status);
            if(statusFlag&&str){
              flag = true;
            }
            break;
            case '已锁定':
            statusFlag = ['50','60'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '设计完成':
            list = id == '3010130'?['30','31','40','50','99']:['30','40','50','99'];
            statusFlag = list.includes(status);
            if(statusFlag&&str){
              flag = true;
            }
            break;
            case '/':
            statusFlag = !['20'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '已超时':
            statusFlag = ['93'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
          }
          return flag;
        }
      },
      // 待确认计时
      confirmTime(){
        return function(row,msg){
          let flag = false;
          let list = [];
          let statusFlag = '';
          let id = row.servCataId;
          let status = row.orderStatus;
          let str = this.timeFormat(row.confirmTime) == '已超时';
          switch(msg){
            case '未激活':
            list = id=='3010130'?['01','10','91','20','93']:['01','10','31','91','20','93']
            statusFlag = list.includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '已锁定':
            statusFlag = ['50','60'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '确认完成':
            statusFlag = ['99'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '/':
            statusFlag = !['30','31','40'].includes(status);
            if(statusFlag){
              flag = true;
            }
            break;
            case '已超时':
            if(str){
              flag = true;
            }
            break;
          }
          return flag;
        }
      }
    },
    methods: {
      loadDataList() {
        this.loading = true;
        this.$api.get({
          // url: '/biz/orderServ/dem/list',
          url: '/biz/orderServ/dem/order',
          data: this.queryParams
        }).then(res => {
          this.externalTime = res.nowTime;
          this.noData = res.total > 0 ? false : true;
          this.total = res.total
          this.orderList = res.rows
          this.loading = false
          // this.orderList.sort((a, b) => {
          //   const statusPriority = {
          //     '01': 1, // 待支付
          //     '60': 2, // 设计师投诉中
          //     '30': 3, // 待确认
          //     '50': 4, // 下单方投诉中
          //     '10': 5, // 待接单
          //     '20': 6, // 设计中
          //     '40': 7, // 更改设计中
          //     '91': 8, // 已取消(发单取消-退款)
          //     '92': 9, // 已取消(客服取消-退款)
          //     '98': 10, // 已结单(客服确认)
          //     '99': 11, // 已结单(发单确认)
          //   };
          //   const aPriority = statusPriority[a.orderStatus] || Number.MAX_SAFE_INTEGER;
          //   const bPriority = statusPriority[b.orderStatus] || Number.MAX_SAFE_INTEGER;
          //   return aPriority - bPriority;
          // })
          this.orderList.forEach((row) => {
            this.daojishi(row);
          })
        })
      },
      daojishi(row) {
        // 因为遍历导致定时任务叠加，所以要重置定时任务
        clearInterval(this.timeDown);
        this.timeDown = setInterval(() => {
          if(this.externalTime>0){
            this.externalTime += 1000;
          }else{
            clearInterval(this.timeDown);
          }
        },1000)

        if (row.orderStatus == "20") {
          row.desCountDown = setInterval(() => {
            let residue = new Date(row.expectTime).getTime() - this.externalTime;
            if (residue > 0) {
              row.desTime = residue;
              this.desKey = Math.random()
            } else {
              clearInterval(row.desCountDown);
            }
          }, 1000)
          row.desTime = new Date(row.expectTime).getTime() - this.externalTime;
        } else if (row.orderStatus != "20") {
          if (row.desCountDown) {
            clearInterval(row.desCountDown)
          }
          row.confirmCountDown = setInterval(() => {
            let residue = new Date(row.expectTime).getTime() - this.externalTime;
            if (residue > 0) {
              row.confirmTime = residue;
              this.confirmKey = Math.random();
            } else {
              clearInterval(row.confirmCountDown);
            }
          }, 1000);
          row.confirmTime = new Date(row.expectTime).getTime() - this.externalTime;
        } else {
          if (row.desCountDown) {
            clearInterval(row.desCountDown);
          }
          if (row.confirmCountDown) {
            clearInterval(row.confirmCountDown);
          }
        }
      },
      handleSelectionChange(selection) {
        this.selectIds = selection.map(item => item.servOrderId);
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.loadDataList()
      },
      changeServCataId() {
        this.queryParams.servCataId = this.queryParams.servCataId[1];
      },
      changeOrderRushFlag() {
        if (this.queryParams.orderRushFlag === '0') {
          this.queryParams.orderRushFlag = '';
        }
        this.loadDataList()
      },
      querySearch() {
        this.loadDataList();
      },
      resetSearch() {
        this.total = 0;
        this.queryParams.pageNum = 1;
        this.queryParams.pageSize = 15;
        this.queryParams.demPatient = '';
        this.queryParams.servOrderNo = '';
        this.queryParams.servCataId = [];
        this.queryParams.orderStatus = '';
        this.queryParams.orderRushFlag = '';
        this.loadDataList();
      },
      clickDetail(servOrderId) {
        if (servOrderId != null) {
          sessionStorage.clear();
          sessionStorage.setItem("orderId", servOrderId)
        }
        this.loading = true
        this.$api.get({
          url: '/biz/orderServ/detail/' + servOrderId
        }).then(res => {
          this.loading = false
          this.dialogDetailVisible = true;
          let name = sessionStorage.getItem('confirmOrder');
          this.activeName = name?name:'info';
          let detailData = {};

          let single = res.data.posSingle;
          let bridge = res.data.posBridge;
          for (var key in res.data) {
            if (key === "posSingle"&&single!=''&&single!=null) {
              let temp = res.data.posSingle.split(',')
              detailData.posSingleList = temp.length === 0 || temp[0] === '' ? [] : temp;
            } else if (key === "posBridge"&&bridge!=''&&bridge!=null) {
              if(res.data.servCataId!='4010110'){
                detailData.posBridgeList = this.parseBridgeStringToArray(res.data.posBridge);
              }else{
                // 处理活动 钢牙/充胶牙 数量
                // 如果res.data.posBridge不包含'/',则根据对应材质数量赋值
                if(res.data.posBridge.includes('/')){
                  let temp =  this.parseBridgeStringToArray(res.data.posBridge);
                  detailData.steelList = temp[0].length>0?temp[0]:[];
                  detailData.glueList = temp[1].length>0?temp[1]:[];
                }else{
                  let steel = res.data.posBridge.split(',').map(item=>parseInt(item));
                  let glue = res.data.posBridge.split(',').map(item=>parseInt(item));
                  detailData.steelList = res.data.servOrderRpd.steelCount>0?steel:[];
                  detailData.glueList = res.data.servOrderRpd.glueCount>0?glue:[];
                }
              }
            } else {
              detailData[key] = res.data[key];
            }
          }
          let status = detailData.orderStatus
          let id = detailData.servCataId
          if (status != '99') {
            if (id == '3010130') {
              detailData.designData = ''
              detailData.designMake = ''
              // 牙位数量填充为一
              detailData.posSingle = ['22']
            } else{
              detailData.designMake = ''
            }
          }
          this.orderDetail = detailData;
          this.orderStatus = detailData.orderStatus
          this.strTo()
          this.$nextTick(() => {
            if (this.orderDetail.orderStatus == '20') {
              this.timing = setInterval(() => {
                this.$api.get({
                  url: '/biz/orderServ/detail/' + servOrderId
                }).then(res => {
                  this.orderStatus = res.data.orderStatus;
                  if (this.orderStatus !== '20') {
                    clearInterval(this.timing)
                  }
                })
              }, 3 * 60 * 1000)
            }
          })
        })
        this.implList = this.common.implList;
      },
      //详情订单显示复合servName拼接
      strTo() {
        let id = this.orderDetail.servCataId;
        this.orderDetail.servName = this.common.serv.get(id).servName;
        if (this.orderDetail.withServCataId) {
          var arr = this.orderDetail.withServCataId.split(',')
          arr.forEach((k, i) => {
            if (id != '1010410' && id != arr[i]) {
              this.orderDetail.servName += '+' + this.common.serv.get(arr[i]).servName;
            }
          })
        }
      },
      clickCloseDetail() {
        this.dialogDetailVisible = false;
        this.activeName = 'info';
        this.orderDetail = {};
        this.reasonImages = []
        clearInterval(this.timing)
        this.orderStatus = '';
        sessionStorage.removeItem('orderId')
        this.loadDataList();
      },
      submitForm(formName, type) {
        if(this.submitLock)return;
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLock = true;
            let formData = new FormData();
            for (var key in that.ruleForm) {
              formData.append(key, that.ruleForm[key]);
            }
            this.addForm(formData, type);
            this.complaintFormVisible = false
            this.dialogFormVisible = false
            setTimeout(()=>{
              this.submitLock = false;
            },3000);
          } else {
            this.$yxz.msg('请填写理由！')
            return false;
          }
        });
      },
      //添加
      addForm(formData, type) {
        var data = {
          servOrderId: this.orderDetail.servOrderId,
          reasonContent: formData.get('content'),
          reasonImages: this.reasonImages.join(','),
          activityType: type
        }
        this.$api.post({
          url: '/biz/orderServ/dem/change',
          data: data
        }).then(res => {
          if (res.code == 200) {
            this.$yxz.msg('提交成功', 'success')
            this.ruleForm.content = ''
            this.reasonImages = []
            this.complaintFormVisible = false
            //更新状态
            this.orderStatus = res.data.orderStatus
          } else {
            this.$yxz.msg(res.msg);
          }
        })
      },
      getPayDetail(row) {
        if (this.selectIds.length == 0) {
          this.selectIds = [];
          this.selectIds.push(row.servOrderId)
        }
        // if(this.selectIds.length >1) {
        //  this.$message({
        //    type: 'warning',
        //    message: '合并支付暂时关闭，请选择单个服务单支付!!'
        //  });
        //   return;
        // }
        this.loading = true
        this.$api.get({
          url: '/biz/orderServ/dem/pay/' + this.selectIds
        }).then(res => {
          this.loading = false
          this.dialogPayVisible = true;
          this.orderPayDetail = res.data;
        })
      },
      clickClosePay() {
        this.selectIds = [];
        this.orderPayDetail = {};
        this.dialogPayVisible = false;
        let id = sessionStorage.getItem('orderId');
        if (id != null) {
          this.clickDetail(id);
        }
        this.loadDataList();
      },
      clickUpdateOrder() {
        sessionStorage.setItem('updateForm', JSON.stringify(this.orderDetail))
        sessionStorage.setItem('step', 2)
        let url = '';
        switch(this.orderDetail.servCataId){
          case '3010130':
            url = '/order/orthodonticsCreateOrder/?servOrderId=';
            break;
          case '4010110':
          case '4010120':
            url = '/order/active/bracket/?servOrderId=';
            break;
          default:
            url = '/order/create/?servOrderId=';
            break;
        }
        this.$router.push({
          path: url + this.orderDetail.servOrderId,
        })
      },
      // 防抖
      debouncedClick() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.clickCancelOrder();
        }, 500); // 1000 毫秒即 1 秒的防抖时间
      },
      clickCancelOrder() {
        this.$confirm('确定取消服务单【' + this.orderDetail.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/dem/cancel/' + this.orderDetail.servOrderId
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '取消成功!'
            });
            this.clickCloseDetail()
            // this.loadDataList();
          })

        }).catch(() => {});
      },
      clickConfirmOrder() {
        if (this.orderDetail.orderStatus == '31') {
          this.getPayDetail(this.orderDetail);
          sessionStorage.setItem('confirmOrder',this.activeName);
          return false;
        }
        this.$confirm('确定确认服务单【' + this.orderDetail.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/dem/comfirm/' + this.orderDetail.servOrderId
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '确认订单成功!'
            });
            this.orderStatus = res.data.orderStatus;
            this.clickDetail(this.orderDetail.servOrderId)
            sessionStorage.setItem('confirmOrder',this.activeName);
          })

        }).catch(() => {});
      },
      // 继续制作
      continueDesign() {
        this.$confirm('确定继续服务单【' + this.orderDetail.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.$api.get({
            url: '/biz/orderServ/dem/continue/' + this.orderDetail.servOrderId,
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '确认订单成功!设计师将继续设计'
            });
            // 注意是否要关闭订单详情
            if (this.orderDetail.servOrderId) {
              this.clickDetail(this.orderDetail.servOrderId)
            }
            // this.loadDataList();
          })
        })
      },
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/order/mall') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      async uploadFile({
        response,
        file,
        data
      }) {
        var loading = this.$loading({
          text: '等待上传完成，已上传 0%'
        });
        var that = this
        uploadByPieces({
          file: file, // 文件
          data: data,
          pieceSize: 3, // 分片大小
          concurrent: 3,
          process: res => {
            loading.setText('等待上传完成，已上传' + res + '%')
            // console.log('分片上传 -> process', res)
            if (res == 100) {
              loading.close();
            }
          },
          success: res => {
            if (data.objectType == '18') { //设计文件
              this.reasonImages.push(res.data.url)
            }
            loading.close();
            // console.log('分片上传 -> success', res)
          },
          error: e => {
            loading.close();
            // console.log('分片上传 -> error', e)
          }
        })
      },
      async fetchData() {
        try {
          this.loadDataList()
        } catch (e) {
          console.error('Error fetching data:', error);
        }
      },
      //删除订单
      removeOrder(row) {
        this.$confirm('确定删除服务单【' + row.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/dem/delete/' + row.servOrderId
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.loadDataList();
          })
        }).catch(() => {});
      },
      /**
       * 解析连桥字符串并转换成二维数组
       *
       * @param {string} str - 输入的连桥字符串，如 "1,2,3/4,5,6/7,8"
       * @returns {number[][]} - 返回解析后的二维数组，输出: [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 7, 8 ] ]
       */
      parseBridgeStringToArray(str) {
        const subStrings = str.split('/');
        const result = [];
        if (subStrings.length === 0 || subStrings[0] === '') {
          return [];
        }
        subStrings.forEach(subStr => {
          const numbers = subStr.split(',').map(Number);
          result.push(numbers);
        });
        return result;
      },
      // 更改设计/投诉上传限制
      beforeUpload(file){
        console.log('file',file)
        if(!['image/jpeg','image/png'].includes(file.type)){
          this.$message({
            type: 'error',
            message: '请上传jpg或png格式的图片'
          });
          return false;
        }
      }
    },
    created() {
      this.timerId = setInterval(() => {
        this.fetchData();
      }, 1 * 60 * 1000);
      this.$store.commit('common/recordNav', {
        navIndex: 1,
        navSubIndex: 1
      })
      this.loadDataList();
      let id = sessionStorage.getItem("orderId")
      if (id) {
        this.clickDetail(id);
      }
    },
    beforeDestroy() {
      // 清除时间
      clearInterval(this.timeDown);
      clearInterval(this.timerId);
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      document.title = "医小智 - 我的服务单"
    },
    components: {
      YShelf,
      YButton,
      SButton,
      BaseTag,
      DictTag,
      ServTag,
      DetailOrder,
      ActiveOrder,
      OrthOrder,
      DetailDown,
      DetailDesign,
      DetailActivity,
      PayOrder,
      Customer
    }
  }
</script>
<style lang="scss">
  @import "../../assets/style/mixin";

  .order {
    display: flex;
    flex-direction: column;
    perspective: 3000px;
    position: relative;
    z-index: 19;
    margin: 10px auto;
  }

  .search-box {
    position: relative;
    overflow: hidden;
    position: relative;
    margin: 10px;
    padding: 10px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #626262;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    .floor-btn {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      border: 1px solid #e1e1e1;
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      border-radius: 5px;
      background: -webkit-linear-gradient(#fbfbfb, #ececec);
      background: linear-gradient(#fbfbfb, #ececec);
      background-image: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#ececec));
      background-image: linear-gradient(180deg, #fbfbfb, #ececec);
    }

    .search-box-left {
      display: flex;
      flex-direction: row;
    }

    .search-item {
      margin-right: 10px;

      &.mt {
        margin-top: 1px;
      }
    }

    .search-box-right {
      display: flex;
      flex-direction: row;
    }

  }

  .option-item {
    display: list-item !important;
  }

  .order-list {
    border-radius: 8px;
    position: relative;
    z-index: 20;
    background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .table-wrap {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
  }

  .code-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 20px;
      height: 20px;
      margin-left: 3px;
      opacity: 0.8;
    }
  }

  .code-color {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 20px;
      height: 20px;
      margin-left: 3px;
      opacity: 0.8;
    }
  }

  .no-info {
    min-height: 527px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dialog-wrap {
    width: 1220px;
    margin: 0 auto;
  }

  .dialog-wrap-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 20px;
    height: 45px;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 32px;
    font-weight: 500;

    label {
      margin: 0 10px;
    }

    img {
      width: 26px;
      height: 26px;
      margin-left: 10px;
      margin-top: -5px;
    }
  }

  .dialog-wrap-content {
    margin: 0 10px;
    margin-top: -30px;
  }

  .tabs-pane-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: normal;

    span {
      margin-left: 5px;
    }

    i {
      font-size: 16px;
    }
  }

  .el-tabs__item.is-active {
    color: #00a5d5;
  }

  .el-tabs__active-bar {
    background-color: #00a5d5;
  }

  .el-tabs__item:hover {
    color: #00a5d5;
    cursor: pointer;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #00a5d5;
  }

  .tabs-pane-content {
    height: calc(100vh - 280px);
    border-bottom: 1px solid #E4E7ED;
    padding: 5px 20px 20px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .el-dialog {
    border-radius: 8px;
    background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 2px;
    height: 50px;
    background: #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.4);
  }

  .el-switch__label.is-active {
    color: #00a5d5;
  }

  .el-switch__label {
    -webkit-transition: .2s;
    transition: .2s;
    font-size: 13px;
    vertical-align: middle;
    color: #909399;
  }

  .el-switch__label * {
    line-height: 1;
    font-size: 13px;
    display: inline-block;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #6c8cd4;
    background-image: -webkit-linear-gradient(top, #6c8cd4, #00a5d5);
    background-image: linear-gradient(180deg, #6c8cd4, #00a5d5);
  }

  .pagination-wrap {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 15px;
  }

  .el-dialog__header {
    padding: 10px 20px 10px;
  }

  .el-pager li.active {
    color: #00a5d5;
    cursor: default;
  }

  .el-pager li:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-left:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-right:hover {
    color: #00a5d5;
  }

  .el-pagination span:not([class*=suffix]) {
    display: inline-block;
    font-size: 12px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .no-data {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pay-wrap-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 45px;
    font-size: 18px;
    font-weight: 500;
  }

  .pay-wrap-content {
    margin: 0 10px;
    margin-top: -60px;
  }

  .txtColor1 {
    color: #ccc;
  }

  .txtColor2 {
    color: #00B050;
    ;
  }

  .txtColor3 {
    color: red;
  }

  .code-color {
    filter: hue-rotate(60%);
  }

  .el-table__body-wrapper {
    overflow-x: hidden !important;
  }
</style>
<style scoped>
  .item:hover {
    text-decoration: underline;
  }

  .item {
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// orderDem.vue?10fe9bb9